import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { ArtifactNotesPresentation } from './artifact-notes.presentation';
import { ArtifactNotesViewModel } from './artifact-notes.viewmodel';

interface ContainerProps {
    assetMetadataId: number;
    note: string;
    closeArtifactNotesPopup: () => void;
    onUpdateArtifactNotes: (assetMetadataId: number, note: string) => void;
}

const ArtifactNotesContainer = withViewModel(ArtifactNotesPresentation, (props: ContainerProps) => {
    const vm = new ArtifactNotesViewModel(
        props.assetMetadataId,
        props.note,
        props.closeArtifactNotesPopup,
        props.onUpdateArtifactNotes
    );
    return vm;
});

export { ArtifactNotesContainer as ArtifactNotesForm };